<header
  class="header-area bg-white border-radius transition"
  [ngClass]="{'active': isSidebarToggled, 'sticky': isSticky}"
  [class.component-dark-theme]="themeService.isDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
  [class.dark-header]="themeService.isHeaderDark()"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
  >
  <div class="d-md-flex align-items-center justify-content-between">
    <div class="header-left-side d-flex align-items-center">
      <div class="burger-menu cursor-pointer transition d-xl-none" [ngClass]="{'active': isSidebarToggled}" (click)="toggle()">
        <span class="top-bar d-block bg-black transition"></span>
        <span class="middle-bar d-block bg-black transition"></span>
        <span class="bottom-bar d-block bg-black transition"></span>
      </div>
      <form class="search-box position-relative">
        <i class="material-symbols-outlined">
          search
        </i>
        <input type="text" class="input-search d-block w-100 border-none outline-0" placeholder="Pretraga..." (input)="onSearchChange($event)">
      </form>
      @if (filterConfig && filterConfig.length > 0) {
        <button  mat-icon-button (click)="openFilterDialog()" matTooltip="Postavite kriterij pretrage">
          <mat-icon>filter_list</mat-icon>
        </button>
      }
      <!-- Breadcrumbs -->
      @if (!isHandset) {
        <div class="breadcrumbs-wrapper d-flex align-items-center ms-3 me-3" style="padding-left: 15px;">
          <app-crumbs></app-crumbs>
        </div>
      }
    </div>
    <ul class="header-right-side d-flex align-items-center mt-0 mb-0 pl-0 list-unstyled">
      <li>
      <!-- <button mat-button class="dark-swtich-btn" (click)="toggleTheme()">
        <i class="material-symbols-outlined">
          dark_mode
        </i>
      </button> -->
    </li>
   @if (user?.isAssociationResponsiblePerson()) {
      <li>
          <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" class="notifications-menu-btn p-0">
            <i class="material-symbols-outlined">
              notifications
            </i>
            @if (unreadCount>0) {
              <span class="daxa-badge">
                {{ unreadCount }}
              </span>
            }
          </button>     
          <mat-menu class="notifications-menu-dropdown" #notificationsMenu="matMenu" xPosition="before">
            <div [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()">
              <div class="title d-flex align-items-center justify-content-between">
                <span class="fw-medium">
                  Obavijesti
                  <span class="text-body fw-normal">({{ unreadCount }})</span>
                </span>
              </div>
              <ul class="menu-body pl-0 mt-0 list-unstyled">
                @for (notification of unreadNotifications; track notification) {
                  <li class="position-relative" (click)="viewNotification(notification)">
                    <div class="icon rounded-circle position-absolute text-center transition">
                      <i class="material-symbols-outlined">
                        notifications
                      </i>
                    </div>
                    <span class="sub-title d-block">{{ notification.title }}</span>
                    <a  class="d-block link-btn position-absolute"></a>
                  </li>
                }
              </ul>
              <div class="menu-footer text-center">
                <a routerLink="/association/notifications" class="link-btn text-daxa d-inline-block fw-medium">
                  Pregledaj sve obavijesti
                </a>
              </div>
            </div>
          </mat-menu> 
      </li>
      }
    <li>
      <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
        <img src="images/admin.png" alt="profile-image">
        <span class="status d-inline-block rounded-circle position-absolute"></span>
      </button>
      <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
        <div
          [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()"
          >
          <div class="menu-header d-flex align-items-center">
            <img src="images/admin.png" alt="profile-image">
            <div class="title">
              <a routerLink="/my-profile" class="d-inline-block fw-medium">
                {{user?.firstName}} {{user?.lastName}}
              </a>
              <span class="designation d-block text-body">
                Općina: {{user?.municipalityName}}
              </span>
            </div>
          </div>
          <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
            <li class="position-relative transition fw-medium">
              <i class="material-symbols-outlined">
                settings
              </i>
              Moj korisnički račun
              <a routerLink="/settings" class="link-btn d-block position-absolute"></a>
            </li>
            <li class="position-relative transition fw-medium">
              <i class="material-symbols-outlined">
                logout
              </i>
              Odjava
              <a routerLink="/authentication/logout" class="link-btn d-block position-absolute"></a>
            </li>
          </ul>
        </div>
      </mat-menu>
    </li>
  </ul>
</div>
</header>